import React, { ChangeEvent, useContext, useState } from "react";
import {
  confirmationMsg,
  generateLoading,
  showAlert,
  showConnectionError,
  stopLoading,
} from "../../promptMessages/PromptMessages";
import { updateForApproval } from "../../api/FetchAPI";
import { AuthContext } from "../AuthContextComponent";
import { ALERTMSG } from "../../lib/enums/AlertMsgs";
import useApprove from "../../hooks/ApproveHook";
import useHeadComponent from "../../hooks/HeaderHook";
import { isAxiosError } from "axios";
import useUserLogin from "../../hooks/UserLoginhook";

interface TextAreaProps {
  batchNumber: any;
  modalClose?: any;
  GetForApproval?: any;
  setApprovalStatus?: any;
}

const TextArea = ({
  batchNumber,
  modalClose,
  GetForApproval,
  setApprovalStatus,
}: TextAreaProps) => {
  const { username, userInfo } = useContext(AuthContext);
  const [rejectionReason, setRejectionReason] = useState("");
  const [isRequired, setIsRequired] = useState(false);
  const { partnerBalance } = useHeadComponent();
  const { handleGetForApproval } = useApprove();
  const { customColor } = useUserLogin();

  const handleReason = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value.trimStart();

    setRejectionReason(value);

    if (value) {
      setIsRequired(false);
    } else {
      setIsRequired(true);
    }
  };

  const handleRejectBatch = async () => {
    try {
      if (!rejectionReason) {
        setIsRequired(true);
        return;
      } else {
        generateLoading("Please wait...");
        setIsRequired(false);
        let requestApproval = {
          userId: username,
          partnersId: userInfo?.partnersId || 0,
          batchNumber: batchNumber,
          isRejected: true,
          rejectReason: rejectionReason,
        };
        const confirmed = await confirmationMsg(
          "Are you sure to reject this transaction?",
          "",
          "",
          "",
          customColor
        );

        if (confirmed) {
          generateLoading("Please wait...");
          const response: any = await updateForApproval(requestApproval);
          const { respCode, respMsg } = response;

          if (respCode === 2000) {
            stopLoading();
            modalClose(false);
            partnerBalance();
            handleGetForApproval();
            setApprovalStatus(true);
            showAlert(
              "Batch Rejected!",
              `Reason: ${rejectionReason}`,
              "warning",
              customColor
            );
          } else if (respCode === 3141) {
            stopLoading();
            partnerBalance();
            handleGetForApproval();
            modalClose(false);
            return;
          } else {
            stopLoading();
            modalClose(false);
            showAlert(ALERTMSG.OOPS, respMsg, "warning", customColor);
          }
        }
      }
    } catch (error: any) {
      if (isAxiosError(error)) {
        const code = error.request.status || error.code;
        showConnectionError(ALERTMSG.SERVDISRUPTION, `(${code})`);
      } else {
        const code = error.response.status || error.code;
        showConnectionError(ALERTMSG.UNDHANDLEDERR, `${code}`);
      }
    }
  };

  return (
    <div className="flex flex-col items-center gap-3">
      {isRequired ? (
        <span className="flex text-custom-micro text-custom-default justify-start w-full px-2">
          Reason is required!
        </span>
      ) : null}
      <textarea
        className={`text-custom-micro border border-gray-400 w-[400px] h-32 -top-10 px-4 py-2 rounded-md ${
          isRequired ? "border-red-500" : ""
        }`}
        placeholder="Reason"
        value={rejectionReason}
        onChange={handleReason}
        required
      ></textarea>

      <div className="flex justify-end items-end w-full">
        <button
          style={{ backgroundColor: customColor }}
          className=" text-custom-micro text-white rounded-md h-9 w-24 hover:bg-custom-default-hover"
          onClick={handleRejectBatch}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default TextArea;
